<template>
	<div class="school-container">

		<div class="school-title">
			<span>基本信息</span>
			<span class="flex-empty"></span>
            <div v-if="isManager">
                <a-button v-if="!isEditStatus" class="fr" icon="edit" @click="isEditStatus = true">编辑</a-button>
                <div v-else>
                    <a-button type="primary" class="fr" :disabled="!canSubmit"
                        @click="updateSchoolInfo">提交</a-button>
                    <a-button class="fr m-right-20" @click="resetSchoolInfo">取消</a-button>
                </div>
            </div>
		</div>

		<div class="school-content" v-if="isEditStatus">
			<div class="width-300">
				<a-upload :customRequest="event => customRequest(event, 'logo')" list-type="picture-card"
					:show-upload-list="false">
					<span v-if="logoInfo.thumbnail_url" class="school-logo_img" :style="getBgStyle(logoInfo.thumbnail_url)"></span>
					<div v-else class="school-logo_img">
						<svg-icon iconClass="photo"></svg-icon>
					</div>
				</a-upload>
				<p class="school-logo_tips" v-if="logoInfo.thumbnail_url">点击图片修改学校Logo</p>
			</div>
			<div class="school-right">
				<div>
					<span class="school-label required-field">学校名称</span>
					<span class="school-item_value">{{ schoolName || "--" }}</span>
				</div>
				<div>
					<span class="school-label">学校介绍</span>
					<a-textarea class="school-des width-600" v-model="schoolInfo.content" placeholder="请输入班级介绍，最多5000字"
						:auto-size="{ minRows: 5 }" :maxLength="2000" style="resize: none" />
				</div>
				<div class="school-background width-600">
					<span class="school-label">班级圈背景</span>
                    <a-upload :customRequest="event => customRequest(event, 'background')"
                        list-type="picture-card" :show-upload-list="false">
						<app-image-view v-if="bgInfo.thumbnail_url" class="school-background_image" :mediaInfo="bgInfo" @click="viewPhoto([bgInfo], 0)"/>
                        <div v-else class="school-photo">
                            <svg-icon iconClass="plus"></svg-icon>
                        </div>
                    </a-upload>
				</div>
			</div>
		</div>

		<div class="school-content" v-else>
			<div class="width-300">
				<app-image-view v-if="logoInfo.thumbnail_url" class="school-logo_img" :mediaInfo="logoInfo"/>
				<span v-else class="school-logo_img" :style="getBgStyle(schoolLogo)"></span>
			</div>
			<div class="school-right">
				<div class="school-item width-600">
					<span class="school-label school-item_label">学校名称</span>
					<span class="school-item_value">{{ schoolName || "--" }}</span>
				</div>
				<div class="school-item width-600">
					<span class="school-label school-item_label">学校介绍</span>
					<span class="school-item_value">{{ schoolInfo.content || "--" }}</span>
				</div>
                <div class="school-background width-600">
					<span class="school-label school-item_label">班级圈背景</span>
					<app-image-view v-if="bgInfo.thumbnail_url" class="school-background_image" :mediaInfo="bgInfo" @click="viewPhoto([bgInfo], 0)"/>
                    <img v-else class="school-background_image" :src="schoolBg" />
                </div>
			</div>
		</div>

		<app-view-img :imageList.sync="imageList" :imageIndex.sync="imageIndex" />
	</div>
</template>
  
<script>
import { mapGetters } from "vuex"
import { uploadHandle } from "@/utils"
import SchoolService from "@/api/schoolService"
import schoolLogo from "@/assets/images/school_logo.png"
import schoolBg from "@/assets/images/school_bg.jpg"
import AppViewImg from "@/components/AppViewImg"
import AppImageView from "@/components/AppImageView"

export default {
  name: "schoolDetail",
  components: { AppViewImg, AppImageView },
  data() {
    return {
      isEditStatus: false,
      schoolLogo,
      schoolBg,
      imageList: [],
      imageIndex: 0,
      schoolName: undefined,
      logoInfo: {},
      bgInfo: {},
      schoolInfo: {},
      originShoolInfo: {},
      isloading: true
    }
  },

  computed: {
    ...mapGetters({
      _schoolInfo: "schoolInfo",
      isManager: "isManager"
    }),
    getBgStyle() {
      return function(thumbnail_url) {
        return {
          background: `url(${thumbnail_url}) no-repeat center center`
        }
      }
    },
    canSubmit() {
      const { logo, background, ...shoolInfo } = this.originShoolInfo

      if (JSON.stringify(this.logoInfo) !== JSON.stringify(logo)) {
        return true
      }

      if (JSON.stringify(this.bgInfo) !== JSON.stringify(background)) {
        return true
      }

      if (JSON.stringify(this.shoolInfo) !== JSON.stringify(shoolInfo)) {
        return true
      }

      return false
    }
  },

  created() {
    this.initHandle()
  },

  methods: {
    initHandle() {
      this.getShoolInfo()
      this.getShoolIntro()
    },

    getShoolInfo() {
      SchoolService.getSchoolInfoService({
        id: this._schoolInfo.id
      }).then(res => {
        this.schoolName = res.name
      })
    },

    getShoolIntro() {
      this.isLoading = true
      SchoolService.getSchoolIntroService({
        id: this._schoolInfo.id
      })
        .then(res => {
          this.isLoading = false
          const { logo, background, ...schoolInfo } = res
          this.originSchoolInfo = JSON.parse(JSON.stringify(res))
          this.logoInfo = logo || {}
          this.bgInfo = background || {}
          this.schoolInfo = schoolInfo
        })
        .catch(() => {
          this.isLoading = false
        })
    },

    viewPhoto(source, index, type = "url") {
      if (!source[index][type] || !source[index][type].startsWith("http")) return
      this.imageList = source.filter(item => item[type] && item[type].startsWith("http")).map(item => item[type])
      this.imageIndex = this.imageList.findIndex(item => item === source[index][type])
    },

    customRequest(event, type) {
      uploadHandle({ file: event.file }).then(imageObj => {
        switch (type) {
          case "logo":
            this.logoInfo = imageObj
            break
          case "background":
            this.bgInfo = imageObj
            break
          default:
            break
        }
      })
    },

    resetSchoolInfo() {
      const originSchoolInfo = JSON.parse(JSON.stringify(this.originSchoolInfo))
      const { logo, background, ...schoolInfo } = originSchoolInfo
      this.schoolInfo = schoolInfo
      this.logoInfo = logo || {}
      this.bgInfo = background || {}
      this.isEditStatus = false
    },

    async updateSchoolInfo() {
      const params = {
        id: this._schoolInfo.id,
        content: this.schoolInfo.content ? this.schoolInfo.content.trim() : "",
        logo_id: this.logoInfo.id,
        background_id: this.bgInfo.id
      }
      SchoolService.updateSchoolIntroService(params)
        .then(() => {
          this.isEditStatus = false
          this.getShoolIntro()
          this.$message.success("操作成功")
        })
        .catch(() => {
          this.$message.error("操作失败，请重新操作")
        })
    }
  }
}
</script>
  
<style lang="less" scoped>
.school {
  &-container {
    margin-top: 15px;
    margin-right: 100px;
    padding-bottom: 20px;
    background-color: #ffffff;

    /deep/.ant-upload-picture-card-wrapper {
      display: inline-block;
      width: auto;
    }

    /deep/.ant-upload-select-picture-card {
      background-color: #ffffff;
      border: none;
    }

    /deep/.ant-upload {
      margin: 0 !important;
      padding: 0 !important;
    }
  }

  &-content {
    display: flex;
    flex-flow: nowrap row;
  }

  &-title {
    display: flex;
    flex-flow: nowrap row;
    align-items: center;
    height: 32px;
    padding: 15px 0;
    box-sizing: content-box;
    line-height: 32px;
    background: #f0f2f5;

    &::before {
      position: relative;
      top: 0px;
      display: inline-block;
      content: "";
      width: 6px;
      height: 6px;
      margin-right: 8px;
      background: #409eff;
      border-radius: 50%;
    }
  }

  &-right {
    width: calc(100% - 300px);
  }

  &-info {
    height: 290px;
    padding: 0 0 0 60px;
    border-radius: 8px;
    background: #ffffff;
  }

  &-label {
    display: block;
    height: 20px;
    margin: 22px 0 14px;
    font-size: 14px;
    color: #343c6a;
    font-weight: bold;
  }

  &-input {
    width: 360px;
    height: 32px;
    border-radius: 4px;
    border-color: #d5d5d5;
  }

  &-select {
    width: 540px;
    height: 32px;
    border-radius: 4px;
    border-color: #d5d5d5;
  }

  &-des {
    width: 770px;
    max-width: calc(100% - 30px);
  }

  &-photolist {
    width: 800px;
    max-width: calc(100% - 30px);
  }

  &-btn {
    border-radius: 8px;
  }

  &-del {
    float: right;
    width: 40px;
    height: 40px;
    margin-top: 52px;
    background: #fe5c73;
    border-radius: 50%;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    cursor: pointer;
  }

  &-deliver {
    height: 1px;
    margin: 30px 0 10px;
    background: #d4d4d4;
  }

  &-logo {
    &_img {
      display: block;
      position: relative;
      width: 153px;
      height: 153px;
      margin: 54px 73px 0;
      border-radius: 50%;
      background: #ececee;
      font-size: 40px;
      line-height: 153px;
      overflow: hidden;
      background-size: cover !important;
    }

    &_tips {
      text-align: center;
      color: #cccccc;
    }
  }

  &-background {
    &_image {
      display: block;
      width: 500px;
      height: 300px;
    }
  }

  &-photo {
    position: relative;
    float: left;
    width: 134px;
    height: 120px;
    border-radius: 4px;
    font-size: 28px;
    line-height: 120px;
    background: #ececee;
    margin: 0 25px 25px 0;
    overflow: hidden;
    cursor: pointer;
    background-size: cover !important;

    &_img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
    }

    &_mask {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }

    &:hover {
      .school-photo_mask {
        display: block;
      }
    }
  }

  &-item {
    width: 400px;
    margin: 22px 0;

    &_label {
      height: 20px;
      margin: 0 0 10px 0;
      font-size: 14px;
      line-height: 20px;
      color: #343c6a;
      font-weight: bold;
    }
  }
}
</style>
